import styled from '@emotion/styled'

import { colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { easing } from 'component-library/__styling/settings/easing'

import { WebLink, WebNavLink, WebLinkProps, WebNavLinkProps } from 'common/navigation/web-link'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { createPropFilter } from 'common/emotion'

export const StyledInHouseLinks = styled('nav')<{ linksStyle: 'regional' | 'standard' }>(
    ({ linksStyle }) => ({
        display: 'flex',
        flexWrap: 'nowrap',
        paddingLeft: linksStyle === 'regional' ? calcRem(8) : calcRem(16),
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'flex-end',
    })
)

export const StyledLink = styled(WebLink, {
    shouldForwardProp: createPropFilter<WebLinkProps>()(['linkStyle']),
})<{ linkStyle: 'regional' | 'standard' }>(({ theme, linkStyle }) => ({
    fontSize: calcRem(13),
    display: 'inline-block',
    height: calcRem(20),
    color: colors.black,
    textDecoration: 'none',
    fontWeight: 500,
    lineHeight: calcRem(20),
    transition: `color ${easing.easeOut.fast}`,

    '&:hover, &:focus': {
        color: theme.sectionValues.primaryColor,
        textDecoration: 'underline',
    },

    '&:focus': {
        outline: 'none',
    },

    ...conditionalStyles(linkStyle === 'standard', {
        padding: calcRem(0, 10, 0),
        '&:first-child': {
            paddingLeft: calcRem(24),
            borderLeft: `1px solid ${colors.thewest.greyHippo}`,
        },
    }),

    ...conditionalStyles(linkStyle === 'regional', {
        padding: calcRem(0, 16),
        borderLeft: `1px solid ${colors.thewest.greyHippo}`,
    }),
}))

export const StyledReturnLink = styled(WebNavLink, {
    shouldForwardProp: createPropFilter<WebNavLinkProps>()(['isPrimary']),
})<{ to: string; isPrimary: boolean }>({
    position: 'relative',
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: calcRem(12),
    height: calcRem(20),
    fontWeight: 600,
    textDecoration: 'none',
    borderLeft: `1px solid ${colors.thewest.greyHippo}`,
    padding: calcRem(0, 16),
})
